<template>

</template>

<script>
import {useMessage, useDialog, useNotification } from "naive-ui"

export default {
    name: "message",
    created () {
        window.$message = useMessage()
        window.$dialog = useDialog()
        window.$notification = useNotification()
    }
}
</script>

<style scoped>

</style>
